import React, { useEffect, useState } from "react";
import { BsJournalArrowUp } from "react-icons/bs";
import { FcPackage } from "react-icons/fc";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CnFInventoryTable from "./CnF Inventory/cnf_inventory_table";
import { Formik, Form } from "formik";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import CustomInput from "../../CustomComponent/custom_input";
import { IventoryPlantInfo } from "../../SchemaInfo/info";
import { CreateCnFInventoryScheama } from "../../Schemas/Farm support/cnf_inventory_schema";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { useSelector } from "react-redux";

const CnFInventory = () => {
  const [refresh, setRefresh] = useState(false);
  const [Plants, setPlant] = useState();
  const [Acc, setAcc] = useState();
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    plantId: "",
    userId: "",
    sortByDate: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/cf-inventorys/all-cf-inventorys", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.inventoryCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/pmg/plants/all-plants")
      .then((res) => {
        if (res.status === 200) {
          setPlant(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/pmg/accessories/all-accessories")
      .then((res) => {
        if (res.status === 200) {
          setAcc(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = (values, actions) => {
    values.accId = values.accId ? +values.accId : null;
    values.plantId = values.plantId ? +values.plantId : null;
    setRefresh(true);
    performRequest("POST", "/pmg/cf-inventorys/create-cf-inventorys", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Inventory created successfully!");

          document.getElementById("model-dismiss").click();
          actions.resetForm();
          setRefresh(!refresh);
          navigate("/farm-cnf-inventory");
        } else {
          Toast("error", "Error while Creating");
        }
        setRefresh(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPackage className="fs-2  me-1" /> My Inventory
                </h2>
                <h4 className="text-muted">Manage your inventory.</h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  <span data-bs-toggle="modal" data-bs-target="#modal-team">
                    <button className="btn btn-primary">
                      <BsJournalArrowUp className="me-2 fs-2" />ADD NEW ITEMS
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Plants:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  plantId: e.target.value,
                                })
                              }
                              value={filters.plantId}
                            >
                              <option value="">Select</option>
                              {Plants?.map((item) => (
                                <option value={item?.id}>
                                  {item?.agronomyWikiUpdate?.name}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Accessories:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  accId: e.target.value,
                                })
                              }
                              value={filters.accId}
                            >
                              <option value="">Select</option>
                              {Acc?.map((item) => (
                                <option value={item?.id}>{item?.name}</option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by Date:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                              value={filters.sortByDate}
                            >
                              <option value="">Select</option>
                              <option value="asc">Ascending</option>
                              <option value="desc">descending</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      plantId: "",
                                      accId: "",
                                      sortByDate: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Plants:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                plantId: e.target.value,
                              })
                            }
                            value={filters.plantId}
                          >
                            <option value="">Select</option>
                            {Plants?.map((item) => (
                              <option value={item?.id}>
                                {item?.agronomyWikiUpdate?.name}
                              </option>
                            ))}
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Accessories:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                accId: e.target.value,
                              })
                            }
                            value={filters.accId}
                          >
                            <option value="">Select</option>
                            {Acc?.map((item) => (
                              <option value={item?.id}>{item?.name}</option>
                            ))}
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Sort by Date:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByDate: e.target.value,
                              })
                            }
                            value={filters.sortByDate}
                          >
                            <option value="">Select</option>
                            <option value="asc">Ascending</option>
                            <option value="desc">descending</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    plantId: "",
                                    userId: "",
                                    sortByDate: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <CnFInventoryTable
                  setRefresh={setRefresh}
                  refresh={refresh}
                  data={data?.inventoryData}
                  currentPage={page}
                  itemsPerPage={50}
                />

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <span data-bs-toggle="modal" data-bs-target="#modal-team">
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" /> ADD NEW ITEMS
                      </button>
                    </span>
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.inventoryData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-team"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <Formik
          initialValues={IventoryPlantInfo}
          validationSchema={CreateCnFInventoryScheama}
          onSubmit={handelSubmit}
          enableReinitialize
        >
          {(props) => (
            <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100 ">
              <div
                className="modal-dialog modal-dialog-centered w-100"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add a new inventory</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3 row">
                      <label className="form-label required">
                        Select Category
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="category"
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            props.setFieldValue("category", e.target.value);
                            props.setFieldValue("plantId", "");
                            props.setFieldValue("accId", "");
                          }}
                        >
                          <option value="">Select</option>
                          <option value="plant">Plant</option>
                          <option value="accessories">Accessories</option>
                        </CustomSelect>
                        {props.touched.category && props.errors.category && (
                          <p className="text-danger">{props.errors.category}</p>
                        )}
                      </div>
                    </div>

                    {props.values.category === "plant" && (
                      <div className="mb-3 row">
                        <label className="form-label required">
                          Select Plant
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            name="plantId"
                            type="text"
                            className="form-control"
                          >
                            <option value="">Select</option>
                            {Plants?.map((item) => (
                              <option value={item?.id} key={item?.id}>
                                {item?.agronomyWikiUpdate?.name}
                              </option>
                            ))}
                          </CustomSelect>
                          {props.touched.plantId && props.errors.plantId && (
                            <p className="text-danger">
                              {props.errors.plantId}
                            </p>
                          )}
                        </div>
                      </div>
                    )}

                    {props.values.category === "accessories" && (
                      <div className="mb-3 row">
                        <label className="form-label required">
                          Select Accessories
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            name="accId"
                            type="text"
                            className="form-control"
                          >
                            <option value="">Select</option>
                            {Acc?.map((item) => (
                              <option value={item?.id} key={item?.id}>
                                {item?.name}
                              </option>
                            ))}
                          </CustomSelect>
                          {props.touched.accId && props.errors.accId && (
                            <p className="text-danger">{props.errors.accId}</p>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="mb-3 row">
                      <label className="form-label required">Quantity</label>
                      <div className="w-100 col">
                        <CustomInput name="quantity" type="text" />
                        {props.touched.quantity && props.errors.quantity && (
                          <p className="text-danger">{props.errors.quantity}</p>
                        )}
                      </div>
                    </div>

                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                        id="model-dismiss"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton buttonText={"Add Item"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <Footer />
    </div>
  );
};

export default CnFInventory;
